import { render, staticRenderFns } from "./AreaPageBody.vue?vue&type=template&id=4f0a8180&scoped=true&"
import script from "./AreaPageBody.vue?vue&type=script&setup=true&lang=js&"
export * from "./AreaPageBody.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a8180",
  null
  
)

export default component.exports